import React from 'react';
import Nav from '../../../components/specific/Navigation';
import { ModalAgregarMarca } from '../../../components/specific/Marca/Modales/agregarMarca';
import TableMarcas from '../../../components/specific/Marca/Table';
import { Toaster } from 'react-hot-toast';
import LoadingTables from '../../../components/global/LoadingTables';
import { ButtonTable } from '../../../components/global/Styles/buttons';
import { TitlesTables } from '../../../components/global/Styles/titles';
import { store } from '../../../store';
import { setSelMarcaInit } from '../../../actions';

const ViewMarca = (props) => {
  const { modalAgregarMarca, setModalAgregarMarca, validate } = props.modal;
  const { loadingTables } = props.data;

  const { getRoles } = props;

  const handleClick = () => {
    store.dispatch(setSelMarcaInit());
    setModalAgregarMarca(true);
  };

  return (
    <div className="flex max-h-screen min-h-screen flex-col overflow-hidden ">
      <Nav />
      <Toaster
        toastOptions={{
          className: 'w-1/2',
        }}
      />

      <div className="flex flex-grow flex-col overflow-hidden ">
        <div className="m-2 flex flex-grow flex-col overflow-hidden   ">
          <div className="flex ">
            <TitlesTables>MARCAS</TitlesTables>
            <div className="flex-auto"></div>

            <ButtonTable onClick={handleClick}>Agregar</ButtonTable>
          </div>

          {loadingTables && <LoadingTables />}
          <TableMarcas
            actions={props.actions}
            data={props.data}
          />
        </div>
      </div>

      {modalAgregarMarca ? (
        <ModalAgregarMarca
          endPoint={props.endPoint}
          agregarMarca={{ validate }}
          setModalModalAgregarMarca={setModalAgregarMarca}
          getRoles={getRoles}
        />
      ) : null}
    </div>
  );
};

export default ViewMarca;
